import { AutogenModelPayrollControlMulticurrency, AutogenRowPayrollControlMulticurrency } from "./autogen/AutogenModelPayrollControlMulticurrency";

export class ModelPayrollControlMulticurrency extends AutogenModelPayrollControlMulticurrency<RowPayrollControlMulticurrency> {
	constructor() {
		super(RowPayrollControlMulticurrency);
	}
}

export class RowPayrollControlMulticurrency extends AutogenRowPayrollControlMulticurrency {
}